import { Switch, FormControlLabel } from '@mui/material';
import { useCaseFieldData, useCaseFieldDispatch } from '../../hooks/useCaseField';
import type { FieldMode } from '../../hooks/useCaseField';
import type { MedNecCaseView } from '../../../../services/MedNecService/types/medNecTypes';

interface CaseSwitchFieldProps {
  mode: FieldMode;
  label: string;
  getValue: (data: MedNecCaseView) => boolean;
  getUpdate: (checked: boolean, data: MedNecCaseView) => Partial<MedNecCaseView>;
}

const CaseSwitchField: React.FC<CaseSwitchFieldProps> = ({ mode, label, getValue, getUpdate }) => {
  const data = useCaseFieldData(mode);
  const { dispatchUpdate, readOnly } = useCaseFieldDispatch(mode);

  return (
    <FormControlLabel
      control={
        <Switch
          checked={getValue(data)}
          onChange={e => dispatchUpdate(getUpdate(e.target.checked, data))}
          size="small"
          disabled={readOnly}
        />
      }
      label={label}
    />
  );
};

export default CaseSwitchField;
